import { TableInputProps } from "../../components/common/table_input/tableInput";
import { TableColumnConfig } from "../../components/sql_table/tableMain";

interface ColumnConfig {
    tableName: string;
    columns: TableColumnConfig[];
    sortOrder?: Record<string, 'asc' | 'desc'>;
};

export const getInputConfig = (carrierOptions?: any[],): Record<string, TableInputProps> => ({
    components_pricing: {
        tableName: 'components_pricing',
        addMultipleRows: false,
        inputColumnConfigs: [
            {
                colName: 'month',
                placeholder: 'Month',
                colType: 'text',
                required: true,
                inputType: 'dropdown',
                dropdownOptions: monthOptions,
            },
            {
                colName: 'year',
                placeholder: 'Year',
                colType: 'number',
                inputType: 'dropdown',
                dropdownOptions: yearOptions,
            },
        ],
    },
    carrier_pricing: {
        tableName: 'carrier_pricing',
        addMultipleRows: false,
        inputColumnConfigs: [
            {
                colName: 'carrier_id',
                placeholder: 'Carrier',
                colType: 'number',
                required: true,
                inputType: 'dropdown',
                dropdownOptions: carrierOptions,
            },
            {
                colName: 'month',
                placeholder: 'Month',
                colType: 'number',
                required: true,
                inputType: 'dropdown',
                dropdownOptions: monthOptionsNumber,
            },
            {
                colName: 'year',
                placeholder: 'Year',
                colType: 'number',
                inputType: 'dropdown',
                dropdownOptions: yearOptions,
            },
        ],
    },
});

export const getColConfig = (): Record<string, ColumnConfig> => ({
    components_pricing: {
        tableName: 'components_pricing',
        sortOrder: {
            year: 'desc',
            month: 'desc',
        },
        columns: [
            { colName: 'id', colHeader: 'ID', colType: 'text', editable: false },
            { colName: 'month', colHeader: 'Month', colType: 'text', editable: false },
            { colName: 'year', colHeader: 'Year', colType: 'number', editable: false },
            { colName: 'cmat', colHeader: 'CMAT', colType: 'accounting', editable: true, decimals: 4,requiresApproval: true, editableLevel:3, approvalLevel: 5, rolesNotAllowedToEdit: ["schedule_admin"] },
            { colName: 'cmaa', colHeader: 'CMAA', colType: 'accounting', editable: true, decimals: 4, requiresApproval: true, editableLevel:3, approvalLevel: 5, rolesNotAllowedToEdit: ["schedule_admin"] },
            { colName: 'plains_wti', colHeader: 'Plains WTI', colType: 'accounting', editable: true, decimals: 4, requiresApproval: true, editableLevel:3, approvalLevel: 5, rolesNotAllowedToEdit: ["schedule_admin"] },
            { colName: 'mid_cush_diff', colHeader: 'Mid Cush Diff', colType: 'accounting', editable: true, decimals: 4, requiresApproval: true, editableLevel:3, approvalLevel: 5, rolesNotAllowedToEdit: ["schedule_admin"] },
            { colName: 'wts', colHeader: 'WTS', colType: 'accounting', editable: true, decimals: 4, requiresApproval: true, editableLevel:3, approvalLevel: 5, rolesNotAllowedToEdit: ["schedule_admin"] },
            { colName: 'wtl', colHeader: 'WTL', colType: 'accounting', editable: true, decimals: 4, requiresApproval:true, editableLevel :3 , approvalLevel : 5, rolesNotAllowedToEdit: ["schedule_admin"] },
            { colName: 'hls', colHeader: 'HLS', colType: 'accounting', editable: true, decimals: 4, requiresApproval:true, editableLevel:3, approvalLevel: 5, rolesNotAllowedToEdit: ["schedule_admin"] },
            { colName: 'argus_p', colHeader: 'Argus P+', colType: 'accounting', editable: true, decimals: 4, requiresApproval:true, editableLevel:3, approvalLevel: 5, rolesNotAllowedToEdit: ["schedule_admin"] },
            { colName: 'cma_diff', colHeader: 'CMA Diff', colType: 'accounting', editable: true, decimals: 4, requiresApproval:true, editableLevel:3, approvalLevel: 5, rolesNotAllowedToEdit: ["schedule_admin"] },
            { colName: 'nymex_2_3_1_3', colHeader: 'Nymex 2/3 1/3', colType: 'accounting', editable: true, decimals: 4, requiresApproval:true, editableLevel:3, approvalLevel: 5, rolesNotAllowedToEdit: ["schedule_admin"] },
            { colName: 'actual_roll', colHeader: 'Actual Roll', colType: 'accounting', editable: true, decimals: 4, requiresApproval:true, editableLevel:3, approvalLevel: 5, rolesNotAllowedToEdit: ["schedule_admin"] },
            { colName: 'meh', colHeader: 'MEH', colType: 'accounting', editable: true, decimals: 4, requiresApproval:true, editableLevel:3, approvalLevel: 5, rolesNotAllowedToEdit: ["schedule_admin"] },
            { colName: 'dapl_jc', colHeader: 'DAPL JC', colType: 'accounting', editable: true, decimals: 4, requiresApproval:true, editableLevel:3, approvalLevel: 5, rolesNotAllowedToEdit: ["schedule_admin"] },
            { colName: 'argus_guernsey', colHeader: 'Argus Guernsey', colType: 'accounting', editable: true, decimals: 4, requiresApproval:true, editableLevel:3, approvalLevel: 5, rolesNotAllowedToEdit: ["schedule_admin"] },
            { colName: 'padd_3', colHeader: 'PADD 3', colType: 'accounting', editable: true, decimals: 4, requiresApproval:true, editableLevel:3, approvalLevel: 5, rolesNotAllowedToEdit: ["schedule_admin"] },
            { colName: 'padd_2', colHeader: 'PADD 2', colType: 'accounting', editable: true, decimals: 4, requiresApproval:true, editableLevel:3, approvalLevel: 5, rolesNotAllowedToEdit: ["schedule_admin"] },
        ],
    },
    carrier_pricing: {
        tableName: 'carrier_pricing',
        sortOrder: {
            year: 'desc',
            month: 'desc',
            carrier_name: 'asc',
        },
        columns: [
            {
                colName: 'id',
                colHeader: 'ID',
                colType: 'text',
                editable: false,
            },
            {
                colName: 'carrier_name',
                colHeader: 'Carrier Name',
                colType: 'text',
                editable: false,
                enableSidepanel: true,
            },
            {
                colName: 'year',
                colHeader: 'Year',
                colType: 'text',
                editable: false,
            },
            {
                colName: 'month',
                colHeader: 'Month',
                colType: 'month',
                editable: false,
            },
        ],
    },
    opis_ngl_prices: {
        tableName: 'opis_ngl_prices',
        sortOrder: {
            price_date: 'desc',
        },
        columns: [
            { colName: 'id', colHeader: 'ID', colType: 'text', editable: false },
            { colName: 'price_date', colHeader: 'Date', colType: 'date', editable: false },
            { colName: 'geography', colHeader: 'Geography', colType: 'text', editable: false },
            { colName: 'nickname', colHeader: 'Component', colType: 'text', editable: false },
            { colName: 'value_type', colHeader: 'Type', colType: 'text', editable: false },
            { colName: 'product', colHeader: 'Product', colType: 'text', editable: false },
            { colName: 'value', colHeader: 'Value (¢/gal)', colType: 'accounting', editable: false, decimals: 4 },
            { colName: 'unit', colHeader: 'Unit', colType: 'text', editable: false },
        ],
    },
    opis_ngl_summary: {
        tableName: 'opis_ngl_summary',
        sortOrder: {
            price_date: 'desc',
        },
        columns: [
            { colName: 'id', colHeader: 'ID', colType: 'text', editable: false },
            { colName: 'price_date', colHeader: 'Date', colType: 'date', editable: false },
            { colName: 'geography', colHeader: 'Geography', colType: 'text', editable: false },
            { colName: 'component', colHeader: 'Component', colType: 'text', editable: false },
            { colName: 'spot_value', colHeader: 'Spot (¢/gal)', colType: 'accounting', editable: false, decimals: 4 },
            { colName: 'mtd_value', colHeader: 'MTD (¢/gal)', colType: 'accounting', editable: false, decimals: 4 },
        ],
    },
});

// Get month options for dropdowns
const VALID_MONTHS = [
    'January', 'February', 'March', 'April', 'May', 'June', 
    'July', 'August', 'September', 'October', 'November', 'December'
];
const monthOptions = VALID_MONTHS.map(month => ({
    value: month,
    label: month
}));
const monthOptionsNumber = VALID_MONTHS.map((month, index) => ({
    value: index + 1,
    label: month
}));

// Get year options from 2020 to current year
const CURRENT_YEAR = new Date().getFullYear() + 1;
const MIN_YEAR = 2019;

// Get year options from 2020 to current year
const yearOptions = Array.from(
    { length: CURRENT_YEAR - MIN_YEAR + 1 },
    (_, i) => ({
        value: String(MIN_YEAR + i),
        label: String(MIN_YEAR + i)
    })
).reverse();


